import { render, staticRenderFns } from "./dataV.vue?vue&type=template&id=796824f1&"
import script from "./dataV.vue?vue&type=script&lang=js&"
export * from "./dataV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports